// Per-hostname runtime configuration for the Angular bundle.
// One bundle is deployed to every App Service slot; each slot selects
// its config at load time based on location.hostname. Because slot-swap
// swaps package contents but not slot hostnames, this remains correct
// across swaps in either direction.

export interface AppConfig {
    production: boolean;
    azureAd: {
        instance: string;
        clientId: string;
        tenantId: string;
    };
    apiUrl: string;
}

interface HostEntry {
    clientId: string;
    apiUrl: string;
    production: boolean;
}

const SHARED = {
    instance: 'https://login.microsoftonline.com/',
    tenantId: '6b5c94bd-feaa-4bb5-bb8b-e30e7384bcb6',
};

const PROD_CLIENT_ID = '634a2d4b-26d0-4c86-9e50-17dd057d1ef1';
const NONPROD_CLIENT_ID = '834b5847-6ff6-463e-bb66-c00c09fbf1a2';

const HOST_TABLE: Readonly<Record<string, HostEntry>> = {
    'cmcjourney.com': {
        clientId: PROD_CLIENT_ID,
        apiUrl: 'https://cmcjourney-webapi.azurewebsites.net/api',
        production: true,
    },
    'www.cmcjourney.com': {
        clientId: PROD_CLIENT_ID,
        apiUrl: 'https://cmcjourney-webapi.azurewebsites.net/api',
        production: true,
    },
    'cmcsc-cmcjourney-v3.azurewebsites.net': {
        clientId: PROD_CLIENT_ID,
        apiUrl: 'https://cmcjourney-webapi.azurewebsites.net/api',
        production: true,
    },
    'cmcsc-cmcjourney-v3-stg.azurewebsites.net': {
        clientId: PROD_CLIENT_ID,
        apiUrl: 'https://cmcjourney-webapi-stg.azurewebsites.net/api',
        production: true,
    },
    'cmcsc-cmcjourney-v3-qa.azurewebsites.net': {
        clientId: NONPROD_CLIENT_ID,
        apiUrl: 'https://cmcjourney-webapi-qa.azurewebsites.net/api',
        production: true,
    },
    'cmcsc-cmcjourney-v3-dev.azurewebsites.net': {
        clientId: NONPROD_CLIENT_ID,
        apiUrl: 'https://cmcjourney-webapi-dev.azurewebsites.net/api',
        production: false,
    },
    'localhost': {
        clientId: NONPROD_CLIENT_ID,
        apiUrl: 'https://localhost:7074/api',
        production: false,
    },
};

const DEFAULT_HOST = 'cmcjourney.com';

export function resolveAppConfig(hostname: string | null | undefined): AppConfig {
    const key = hostname ?? DEFAULT_HOST;
    const entry = HOST_TABLE[key] ?? HOST_TABLE[DEFAULT_HOST];
    if (!HOST_TABLE[key]) {
        // eslint-disable-next-line no-console
        console.warn(
            `[host-config] Unknown hostname "${key}" — defaulting to ${DEFAULT_HOST}. ` +
                `Add this host to HOST_TABLE if it is a valid slot.`
        );
    }
    return {
        production: entry.production,
        azureAd: {
            instance: SHARED.instance,
            clientId: entry.clientId,
            tenantId: SHARED.tenantId,
        },
        apiUrl: entry.apiUrl,
    };
}
